import React, { useState, useEffect } from 'react';

import messages from './messages';
import axios from 'axios';
import TOCListWithFilters from "./toc/TOCListWithFilters";
import SearchBar from './search/SearchBar';

const showMoreLinks = (themeCode, lang) => {
  const trans = messages[lang];
  switch (themeCode) {
    case 'gdp':
      return (
        <React.Fragment>
          <h3>{trans.moreLinks}</h3>
          <ul>
            { lang === 'hu' 
            ? (
            <li><a href="https://statisztika.mnb.hu/idosor-1257" target="_blank">{trans.morePenzugyiSzamlak}</a></li>
            ) : (
            <li><a href="https://statisztika.mnb.hu/timeseries/data-6156" target="_blank">{trans.morePenzugyiSzamlak}</a></li>
            )
            }
          </ul>
        </React.Fragment>
      );
    case 'mun':
      return (
        <React.Fragment>
          <h3>{trans.moreLinks}</h3>
            { lang === 'en'
              ? (
                <ul>
                  <li><a href="https://www.ksh.hu/stadat_files/melleklet/labour-annual-status-of-population-aged-15-64.pdf">Labour market status of population aged 15–64, 2020 (Figure)</a></li>
                  <li><a href="https://www.ksh.hu/stadat_files/melleklet/labour-annual-status-of-population-aged-15-74.pdf">Labour market status of population aged 15–74, 2020 (Figure)</a></li>
                  <li><a href="https://www.ksh.hu/stadat_files/melleklet/labour-infra-annual-status-of-population-aged-15-64.pdf">Labour market status of population aged 15–64, in 1st Quarter 2022 (pdf, Figure)</a></li>
                  <li><a href="https://www.ksh.hu/stadat_files/melleklet/labour-infra-annual-status-of-population-aged-15-74.pdf">Labour market status of population aged 15–74, in 1st Quarter 2022 (pdf, Figure)</a></li>
                  <li><a href="https://www.ksh.hu/stadat_annual_2_1r">Data produced according to the former methodology until 2020 (annual tables)</a></li>
                  <li><a href="https://www.ksh.hu/stadat_infra_2_1r">Data produced according to the former methodology until 2020 (infra-annual tables)</a></li>
                  <li><a href="https://www.ksh.hu/stadat_infra_9_tart">Tables of the supplementary surveys of the Labour Force Survey</a></li>
                </ul>
              ) : (
                <ul>
                  <li><a href="https://www.ksh.hu/stadat_files/melleklet/munkaero-eves-15-64-eves-nepesseg-statusza.pdf">A 15–64 éves népesség munkaerő-piaci státusa 2020. évben (pdf, folyamatábra)</a></li>
                  <li><a href="https://www.ksh.hu/stadat_files/melleklet/munkaero-eves-15-74-eves-nepesseg-statusza.pdf">A 15–74 éves népesség munkaerő-piaci státusa 2020. évben (pdf, folyamatábra)</a></li>
                  <li><a href="https://www.ksh.hu/stadat_files/melleklet/munkaero-evkozi-15-64-eves-nepesseg-statusza.pdf">A 15–64 éves népesség munkaerőpiaci státusa 2022. I. negyedévében (pdf, folyamatábra)</a></li>
                  <li><a href="https://www.ksh.hu/stadat_files/melleklet/munkaero-evkozi-15-74-eves-nepesseg-statusza.pdf">A 15–74 éves népesség munkaerőpiaci státusa 2022. I. negyedévében (pdf, folyamatábra)</a></li>
                  <li><a href="https://www.ksh.hu/stadat_eves_2_1r">Korábbi módszertan alapján előállított adatok 2020-ig (éves táblák)</a></li>
                  <li><a href="https://www.ksh.hu/stadat_evkozi_2_1r">Korábbi módszertan alapján előállított adatok 2020-ig (évközi táblák)</a></li>
                  <li><a href="https://www.ksh.hu/stadat_evkozi_9_tart">Lakossági munkaerő-felmérés kiegészítő felvételeinek táblái</a></li>
                </ul>
              )
            }
        </React.Fragment>
      );
    default:
      return null;
  }
};

function alterTableData(stadat) {
  for (let t of stadat.tables) {
    if (t.updatedAt) {
      t.updatedAt = new Date(t.updatedAt);
    }
    if (t.correctedAt) {
      t.correctedAt = new Date(t.correctedAt);
    }
    if (t.updateDates) {
      t.updateDates = t.updateDates.map(d => new Date(d));

      const dt = Math.min.apply(null, t.updateDates.filter(d => d > t.updatedAt));
      if (dt !== Infinity) {
        t.nextUpdate = new Date(dt);
      }
    }
    if (t.relatedFirstReleases) {
      t.relatedFirstReleases = t.relatedFirstReleases.map(x => x.toLowerCase());
    }
  }
  return stadat;
}

const loadingData = (lang) => (
  <h3 style={{ textAlign: 'center', paddingTop: '50px' }}><p>{messages[lang].loadingData}</p></h3>
);

export default function TOC({ themeCode, lang }) {
  const { REACT_APP_TOC_BASEURL } = process.env;
  const [data, setData] = useState({ meta: { version: 0 }, tables: [] });

  useEffect(() => {
    axios(`${REACT_APP_TOC_BASEURL}/${themeCode}/toc.json`)
      .then(d => setData(alterTableData(d.data)), console.error);
  }, [themeCode, REACT_APP_TOC_BASEURL]);

  const trans = messages[lang];

  return (
    <React.Fragment>
      <h1 id="content-title">{trans.tema[themeCode]}</h1>
      <SearchBar {...{ lang }} />
      <h3>{trans.filterTitle}</h3>
      { data.tables[0] ? <TOCListWithFilters header={showMoreLinks(themeCode, lang)} tables={data.tables} lang={lang} showRelatedFirstReleases={true} /> : loadingData(lang)}
    </React.Fragment>
  );
};
